import { format } from 'date-fns';
import { DATE_FORMAT_YYYY_MM_DD } from 'src/components/DatePickerInput/DatePickerInput';
import { InsightsFormFields } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsFormWrapper/InsightsFormWrapper';
import {
  FilterDetail,
  FilterType,
} from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/types/InsightsDashboard';
import { ReportFiltersPayload } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/types/reportFilters';

export const getDateRangeFilterParameterName = (
  filterDetails: FilterDetail[]
): string | undefined => {
  const dateRangeFilterDetail = filterDetails.find(
    (detail) => detail.type === FilterType.DATE_RANGE
  );

  return dateRangeFilterDetail?.parameterName;
};

export const getLocationsFilterParameterName = (
  filterDetails: FilterDetail[]
): string | undefined => {
  const locationsFilterDetail = filterDetails.find(
    (detail) => detail.type === FilterType.MULTI_SELECTOR
  );

  return locationsFilterDetail?.parameterName;
};

export const getReportFilterValues = (
  formData: InsightsFormFields,
  filterDetails: FilterDetail[]
): ReportFiltersPayload | undefined => {
  const dateRangeFilterParameterName =
    getDateRangeFilterParameterName(filterDetails);
  const locationsFilterParameterName =
    getLocationsFilterParameterName(filterDetails);

  const formattedDateRangeValues = {
    startDate: format(formData.insightsDateRange.from, DATE_FORMAT_YYYY_MM_DD),
    endDate: format(formData.insightsDateRange.to, DATE_FORMAT_YYYY_MM_DD),
  };

  const formattedLocationsValues =
    formData.insightsLocations?.map((location) => ({
      id: location.id,
      displayName: location.displayName,
    })) ?? [];

  const isLocationsParameterValid = !!locationsFilterParameterName;

  if (!isLocationsParameterValid && formattedLocationsValues.length > 0) {
    // Should return empty result, if locations are selected but the parameter name is not available
    // This will prevent showing report which is not aligned with applied filters
    return undefined;
  }

  const configuredDateRangeData = {
    [dateRangeFilterParameterName]: {
      dateRange: formattedDateRangeValues,
    },
  };

  const isLocationsDataAvailable =
    locationsFilterParameterName && formattedLocationsValues.length > 0;

  const configuredLocationsData = isLocationsDataAvailable
    ? {
        [locationsFilterParameterName]: {
          multiSelector: {
            values: formattedLocationsValues,
          },
        },
      }
    : {};

  return {
    reportFilters: {
      ...configuredDateRangeData,
      ...configuredLocationsData,
    },
  };
};
